import { Colors } from '@zapier/theme';
export const MEDIA_MIN_TABLET = '@media (min-width: 768px)';
export const MEDIA_MIN_DESKTOP = '@media (min-width: 1080px)';
export const navLinkBaseCss = {
  color: Colors.adamantium,
  textDecoration: 'none',
  transition: 'color .2s ease-in-out',
  '&:hover': {
    color: Colors.white,
    textDecoration: 'none',
    // This mimics a fontWeight of semi-bold but without the horz sizing flicker.
    textShadow: `-0.03ex 0 0 ${Colors.white}, 0.03ex 0 0 ${Colors.white}`,
  },
};
